import * as React from 'react';
import {useState} from 'react';
import {indexBy} from 'ramda';
import {date} from 'ka-erp-data';
import {PanelContext} from 'react-popup-context';
import ProductCategories from './product-categories';
import {ArrowLeft, Ok} from '../common/btns';
import Head from './order-editor/head';
import Body from './order-editor/body';
import {result} from '../../lib/result';

const css = require('./order-editor.css').default;
const headerCss = require('../common/header.css').default;

export default function({ctx, receivers, products, onDone, onClose}: {
    ctx: PanelContext,
    receivers: receiver[],
    products: product[],
    onDone: (order: newOrder) => void,
    onClose: () => void,
}) {
    const [memo, setMemo] = useState<string | null>(null);
    const [deliverDate, setDeliverDate] = useState<date | null>(null);
    const [receiver, setReceiver] = useState<receiver | null>(null);
    const [items, setItems] = useState<item[]>([]);
    const [creating, setCreating] = useState(false);

    const productByCode = indexBy(i => i.code, products);

    function pick() {
        ctx.popup(<ProductCategories
            ctx={ctx}
            products={products}
            onDone={codes => {
                const newbies = codes
                .map(code => ({
                    product: productByCode[code],
                    classQty: 0,
                    classCnt: 1,
                    memo: null,
                }));
                setItems(items => items.concat(newbies));
                ctx.close();
            }}/>);
    }

    return (
    <>
        <div id={headerCss.header}>
            <ArrowLeft width={25} height={25} onClick={onClose}/>
            <div>新增訂單</div>
            <div className='space'/>
            {(() => {
                if (creating) {
                    return <span>新增中...</span>
                } else {
                    return (
                    <>
                        <span className='button' onClick={() => onClose()}>取消</span>
                        <Ok width={30} height={30} color='green'
                            onClick={() => {
                                const res = check({
                                    deliverDate, memo,
                                    receiver: receiver?.id || null,
                                    items: items.map(({product, classQty, classCnt, memo}) => ({
                                        product, classCnt, memo,
                                        qty: classQty * classCnt,
                                    })),
                                });
                                if (result.ok(res)) {
                                    setCreating(true);
                                    const [_, ord] = res;
                                    onDone(ord);
                                } else {
                                    const [error, _] = res;
                                    alert(error);
                                }
                            }}
                        />
                    </>);
                }
            })()}
        </div>
        <div>
            <Head data={{receiver, deliverDate, memo}} receivers={receivers}
                onReceiverChange={setReceiver}
                onDeliverDateChange={setDeliverDate}
                onMemoChange={setMemo}/>
            <Body items={items} onChange={setItems}/>
            <div id={css.addItem} onClick={pick}>新增產品</div>
        </div>
    </>);
}

function check(ord: newOrder): result<newOrder> {
    if (ord.items.length === 0) {
        return ['請選擇訂購產品', null];
    } else if (ord.items.some(item => item.qty === 0 || item.classCnt === 0)) {
        return ['產品數量及班級數不可為零', null];
    } else {
        return [null, ord];
    }
}

type newOrder = {
    deliverDate: date | null,
    receiver: string | null,
    memo: string | null,
    items: {
        product: {
            code: string,
        },
        qty: number,
        classCnt: number,
        memo: string | null,
    }[],
}

type item = {
    product: {
        code: string,
        name: string,
    },
    classQty: number,       // 每班訂購數量
    classCnt: number,
    memo: string | null,
}

type receiver = {
    id: string,
    name: string | null,
    address: string,
}

type product = {
    id: string,
    code: string,
    name: string,
    memo: string | null,
}
